import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import dayjs from 'dayjs';
import styled from 'styled-components';
import Select from 'react-dropdown-select';

import SpinnerLoad from '../common/spinner';
import PaginationComponent from '../common/pagination';
import constants from '../../const';
import { connect } from 'react-redux';

const PageContainer = styled.div`
    background: linear-gradient(135deg, #f0f9fc 0%, #f3f4f6 100%);
    min-height: 100vh;
    padding: 30px 0;
`;

const HeaderSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 24px;

    h1 {
        font-size: 36px;
        font-weight: 700;
        color: #333;
        margin: 0;
    }
`;

const FiltersBar = styled.div`
    background: white;
    border-radius: 12px;
    padding: 16px 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    margin-bottom: 24px;
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
`;

const SearchInput = styled.input`
    flex: 1;
    min-width: 200px;
    padding: 10px 16px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #0f766e;
    }
`;

const FilterButton = styled.button`
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
    color: white;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(15, 118, 110, 0.3);
    }
`;

const SortSelect = styled.select`
    padding: 10px 12px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    background: white;

    &:focus {
        outline: none;
        border-color: #0f766e;
    }
`;

const MoviesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 24px;
`;

const MovieCard = styled(Link)`
    text-decoration: none;
    color: inherit;
    border-radius: 12px;
    overflow: hidden;
    background: white;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 8px 30px rgba(15, 118, 110, 0.25);
        color: inherit;
        text-decoration: none;
    }
`;

const PosterContainer = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 2 / 3;
    background: #e0e0e0;
    overflow: hidden;
`;

const PosterImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const PosterFallback = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
    color: white;
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    padding: 16px;
`;

const SceneCountBadge = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.75);
    color: white;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
`;

const CardInfo = styled.div`
    padding: 12px;
`;

const MovieTitle = styled.div`
    font-weight: 700;
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const MovieSite = styled.div`
    font-size: 12px;
    color: #0f766e;
    font-weight: 600;
`;

const MovieDate = styled.div`
    font-size: 11px;
    color: #999;
    margin-top: 2px;
`;

const CountText = styled.span`
    font-size: 14px;
    color: #666;
    font-weight: 500;
`;

function MoviesBrowse(props) {
    const history = useHistory();
    const params = queryString.parse(props.location.search);

    const [movies, setMovies] = useState([]);
    const [total, setTotal] = useState(0);
    const [sites, setSites] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState(params.search || '');
    const [site, setSite] = useState(params.site ? parseInt(params.site) : -1);
    const [sort, setSort] = useState(params.sort || 'title');
    const [direction, setDirection] = useState(params.direction || 'asc');
    const [page, setPage] = useState(params.page ? parseInt(params.page) : 1);
    const [size, setSize] = useState(params.size ? parseInt(params.size) : 20);
    const [posterErrors, setPosterErrors] = useState({});

    var token = `?token=${localStorage.getItem('token').slice(7)}`;

    const buildUrl = (overrides = {}) => {
        const p = {
            search: overrides.search !== undefined ? overrides.search : search,
            site: overrides.site !== undefined ? overrides.site : site,
            sort: overrides.sort !== undefined ? overrides.sort : sort,
            direction: overrides.direction !== undefined ? overrides.direction : direction,
            page: overrides.page !== undefined ? overrides.page : page,
            size: overrides.size !== undefined ? overrides.size : size,
        };
        return `/scene-movies?search=${p.search}&site=${p.site}&sort=${p.sort}&direction=${p.direction}&page=${p.page}&size=${p.size}`;
    };

    const fetchMovies = (overrides = {}) => {
        setLoading(true);
        const p = {
            search: overrides.search !== undefined ? overrides.search : search,
            site: overrides.site !== undefined ? overrides.site : site,
            sort: overrides.sort !== undefined ? overrides.sort : sort,
            direction: overrides.direction !== undefined ? overrides.direction : direction,
            page: overrides.page !== undefined ? overrides.page : page,
            size: overrides.size !== undefined ? overrides.size : size,
        };
        history.push(buildUrl(overrides));
        axios.get(`${constants.DATA1_API_URL}/scenes/movies-list`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` },
            params: p
        })
        .then(res => {
            setMovies(res.data.movies);
            setTotal(res.data.total);
            setSites(res.data.sites);
            setLoading(false);
        })
        .catch(() => setLoading(false));
    };

    useEffect(() => {
        fetchMovies();
    }, []);

    const handleSearch = () => {
        setPage(1);
        fetchMovies({ page: 1 });
    };

    const handleSiteChange = (val) => {
        const siteId = val.length > 0 ? val[0].id : -1;
        setSite(siteId);
        setPage(1);
        fetchMovies({ site: siteId, page: 1 });
    };

    const handleSortChange = (e) => {
        const newSort = e.target.value;
        setSort(newSort);
        setPage(1);
        fetchMovies({ sort: newSort, page: 1 });
    };

    const handleDirectionToggle = () => {
        const newDir = direction === 'asc' ? 'desc' : 'asc';
        setDirection(newDir);
        setPage(1);
        fetchMovies({ direction: newDir, page: 1 });
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
        fetchMovies({ page: newPage });
    };

    const handlePosterError = (movieId) => {
        setPosterErrors(prev => ({ ...prev, [movieId]: true }));
    };

    const getMoviePosterUrl = (movie) => {
        return `${constants.CONTENT_DOMAIN}download/sus-media/movies/${movie.id}/poster.webp${token}`;
    };

    const getFallbackPosterUrl = (movie) => {
        if (movie.firstScenePoster) {
            return `${constants.TRAILER_CDN}${movie.firstScenePoster}`;
        }
        return null;
    };

    return (
        <PageContainer>
            <Container style={{ maxWidth: '1400px' }}>
                <HeaderSection>
                    <h1>Movies</h1>
                    <CountText>{total} movies</CountText>
                </HeaderSection>

                <FiltersBar>
                    <SearchInput
                        placeholder="Search movies..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    <FilterButton onClick={handleSearch}>Search</FilterButton>
                    <div style={{ minWidth: '200px' }}>
                        <Select
                            options={sites}
                            labelField="name"
                            valueField="id"
                            searchBy="name"
                            placeholder="All Sites"
                            onChange={handleSiteChange}
                            values={site !== -1 ? sites.filter(s => s.id === site) : []}
                            clearable
                            searchable
                            dropdownHandle
                            style={{ borderRadius: '8px', border: '2px solid #e0e0e0', padding: '4px' }}
                        />
                    </div>
                    <SortSelect value={sort} onChange={handleSortChange}>
                        <option value="title">Title</option>
                        <option value="date">Date</option>
                        <option value="scenes">Scene Count</option>
                        <option value="id">Recently Added</option>
                    </SortSelect>
                    <SortSelect value={size} onChange={(e) => { const s = parseInt(e.target.value); setSize(s); setPage(1); fetchMovies({ size: s, page: 1 }); }}>
                        <option value="20">20</option>
                        <option value="32">32</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </SortSelect>
                    <FilterButton onClick={handleDirectionToggle} style={{ padding: '10px 14px' }}>
                        {direction === 'asc' ? '↑' : '↓'}
                    </FilterButton>
                </FiltersBar>

                <Row className="justify-content-center mb-3">
                    <PaginationComponent
                        params={{ page, size }}
                        totalItem={total}
                        paginate={handlePageChange}
                        baseUrl={`/scene-movies?search=${search}&site=${site}&sort=${sort}&direction=${direction}&size=${size}&page=`}
                    />
                </Row>

                {loading ? <SpinnerLoad /> : (
                    <MoviesGrid>
                        {movies.map(movie => (
                            <MovieCard key={movie.id} to={`/movie/${movie.id}`}>
                                <PosterContainer>
                                    {posterErrors[movie.id] ? (
                                        getFallbackPosterUrl(movie) ? (
                                            <PosterImage
                                                src={getFallbackPosterUrl(movie)}
                                                alt={movie.title}
                                                onError={() => {}}
                                            />
                                        ) : (
                                            <PosterFallback>{movie.title}</PosterFallback>
                                        )
                                    ) : (
                                        <PosterImage
                                            src={getMoviePosterUrl(movie)}
                                            alt={movie.title}
                                            onError={() => handlePosterError(movie.id)}
                                        />
                                    )}
                                    {movie.sceneCount > 0 && (
                                        <SceneCountBadge>{movie.sceneCount} scenes</SceneCountBadge>
                                    )}
                                </PosterContainer>
                                <CardInfo>
                                    <MovieTitle>{movie.title}</MovieTitle>
                                    {movie.siteName && <MovieSite>{movie.siteName}</MovieSite>}
                                    {movie.releaseDate && (
                                        <MovieDate>{dayjs(movie.releaseDate).format('MMM YYYY')}</MovieDate>
                                    )}
                                </CardInfo>
                            </MovieCard>
                        ))}
                    </MoviesGrid>
                )}

                <Row className="justify-content-center mt-4">
                    <PaginationComponent
                        params={{ page, size }}
                        totalItem={total}
                        paginate={handlePageChange}
                        baseUrl={`/scene-movies?search=${search}&site=${site}&sort=${sort}&direction=${direction}&size=${size}&page=`}
                    />
                </Row>
            </Container>
        </PageContainer>
    );
}

const mapStateToProps = (state) => ({
    perms: state.users.permissions.perms
});

export default connect(mapStateToProps)(MoviesBrowse);
